'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaAutomobile = function FaAutomobile(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm9.3 23.7q0-1.3-0.9-2.2t-2.2-0.9-2.2 0.9-0.9 2.2 0.9 2.2 2.2 0.9 2.2-0.9 0.9-2.2z m0.7-6.2h19.7l-1.7-6.9q0-0.2-0.3-0.4t-0.4-0.1h-14.9q-0.2 0-0.4 0.1t-0.3 0.4z m26.6 6.2q0-1.3-0.9-2.2t-2.2-0.9-2.2 0.9-0.9 2.2 0.9 2.2 2.2 0.9 2.2-0.9 0.9-2.2z m3.2-1.8v7.4q0 0.3-0.2 0.5t-0.5 0.1h-1.8v2.5q0 1.6-1.1 2.7t-2.7 1-2.6-1-1.1-2.7v-2.5h-19.9v2.5q0 1.6-1 2.7t-2.7 1-2.6-1-1.1-2.7v-2.5h-1.9q-0.3 0-0.4-0.1t-0.2-0.5v-7.4q0-1.8 1.3-3.1t3-1.3h0.6l2-8.1q0.5-1.8 2-3.1t3.5-1.2h14.9q1.9 0 3.5 1.2t2 3.1l2.1 8.1h0.5q1.8 0 3.1 1.3t1.3 3.1z' })
        )
    );
};

exports.default = FaAutomobile;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/fa/automobile.js
// module id = 107
// module chunks = 61762850755587 79611799117203 213534597649335